// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Survey_progressMain__1uJ2e {
  background: var(--bg3);
  padding: 16px;
  border-radius: var(--border-radius-large);
}
.Survey_progressMain__1uJ2e .Survey_completeProfileTitle__CtxGy {
  font: var(--h6);
  font-weight: 600;
  margin: 0 0 16px 0;
  color: var(--primary-Text);
}
.Survey_progressMain__1uJ2e .Survey_getStartRow__aNRDP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}
.Survey_progressMain__1uJ2e .Survey_getStartRow__aNRDP h6 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--brand);
  text-transform: capitalize;
}
.Survey_progressMain__1uJ2e .Survey_getStartRow__aNRDP button img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

.Survey_modalBody__WYvGJ {
  max-width: 800px !important;
}

.Survey_header__NYGPq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}
.Survey_header__NYGPq h3 {
  font: var(--h6);
  font-weight: 600;
  color: var(--primary-Text);
}

.Survey_formField__e65CP .Survey_label__40GBi {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}

.Survey_photographyTimelineRow__k934z {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: 15px 0;
}
.Survey_photographyTimelineRow__k934z .Survey_formField__e65CP {
  width: 100%;
}
.Survey_photographyTimelineRow__k934z .Survey_deleteRowBtn__tcVyl {
  width: 40px;
}
.Survey_photographyTimelineRow__k934z .Survey_deleteRowBtn__tcVyl button {
  width: 100%;
}

.Survey_formWrp__73r1W {
  max-height: 480px;
  overflow-y: auto;
}

.Survey_ceremonyForm__jgVfd .Survey_checkFormField__Dg-Xv,
.Survey_receptionForm__ii9bY .Survey_checkFormField__Dg-Xv {
  background-color: #EDE1DC;
  padding: 16px;
  border-radius: var(--border-radius);
}
.Survey_ceremonyForm__jgVfd .Survey_checkFormField__Dg-Xv h4,
.Survey_receptionForm__ii9bY .Survey_checkFormField__Dg-Xv h4 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 8px;
}
.Survey_ceremonyForm__jgVfd .Survey_checkFormField__Dg-Xv ul,
.Survey_receptionForm__ii9bY .Survey_checkFormField__Dg-Xv ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Survey_ceremonyForm__jgVfd .Survey_checkFormField__Dg-Xv ul li,
.Survey_receptionForm__ii9bY .Survey_checkFormField__Dg-Xv ul li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Survey_fieldTitle__z2oQI {
  font: var(--body-font-three) !important;
  font-weight: 600 !important;
  color: var(--primary-Text) !important;
  margin-bottom: 0 !important;
}

@media (max-width: 599px) {
  .Survey_formWrp__73r1W {
    max-height: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/WeddingDashboard/Survey/index.module.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,aAAA;EACA,yCAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AACR;AAEI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAAR;AAEQ;EACI,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAAZ;AAIY;EACI,WAAA;EACA,YAAA;EACA,+BAAA;AAFhB;;AAQA;EACI,2BAAA;AALJ;;AAQA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AALJ;AAOI;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;AALR;;AAUI;EACI,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAPR;;AAWA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AARJ;AAUI;EACI,WAAA;AARR;AAWI;EACI,WAAA;AATR;AAWQ;EACI,WAAA;AATZ;;AAcA;EACI,iBAAA;EACA,gBAAA;AAXJ;;AAgBI;;EACI,yBAAA;EACA,aAAA;EACA,mCAAA;AAZR;AAcQ;;EACI,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAXZ;AAcQ;;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAXZ;AAaY;;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAVhB;;AAgBA;EACI,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;AAbJ;;AAgBA;EACI;IACI,iBAAA;EAbN;AACF","sourcesContent":[".progressMain {\r\n    background: var(--bg3);\r\n    padding: 16px;\r\n    border-radius: var(--border-radius-large);\r\n\r\n    .completeProfileTitle {\r\n        font: var(--h6);\r\n        font-weight: 600;\r\n        margin: 0 0 16px 0;\r\n        color: var(--primary-Text);\r\n    }\r\n\r\n    .getStartRow {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-top: 16px;\r\n\r\n        h6 {\r\n            font: var(--body-font-three);\r\n            font-weight: 600;\r\n            color: var(--brand);\r\n            text-transform: capitalize;\r\n        }\r\n\r\n        button {\r\n            img {\r\n                width: 20px;\r\n                height: 20px;\r\n                filter: brightness(0) invert(1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.modalBody {\r\n    max-width: 800px !important;\r\n}\r\n\r\n.header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 16px;\r\n    margin-bottom: 12px;\r\n\r\n    h3 {\r\n        font: var(--h6);\r\n        font-weight: 600;\r\n        color: var(--primary-Text);\r\n    }\r\n}\r\n\r\n.formField {\r\n    .label {\r\n        font: var(--body-font-three);\r\n        color: var(--secondary-Text);\r\n        display: block;\r\n        margin-bottom: 4px;\r\n    }\r\n}\r\n\r\n.photographyTimelineRow {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 16px;\r\n    margin: 15px 0;\r\n\r\n    .formField {\r\n        width: 100%;\r\n    }\r\n\r\n    .deleteRowBtn {\r\n        width: 40px;\r\n\r\n        button {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.formWrp {\r\n    max-height: 480px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.ceremonyForm,\r\n.receptionForm {\r\n    .checkFormField {\r\n        background-color: #EDE1DC;\r\n        padding: 16px;\r\n        border-radius: var(--border-radius);\r\n\r\n        h4 {\r\n            font: var(--body-font-three);\r\n            font-weight: 600;\r\n            color: var(--primary-Text);\r\n            margin-bottom: 8px;\r\n        }\r\n\r\n        ul {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 8px;\r\n\r\n            li {\r\n                display: flex;\r\n                align-items: center;\r\n                gap: 8px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.fieldTitle {\r\n    font: var(--body-font-three) !important;\r\n    font-weight: 600 !important;\r\n    color: var(--primary-Text) !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n@media (max-width: 599px) {\r\n    .formWrp {\r\n        max-height: 300px;\r\n    }\r\n}   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressMain": `Survey_progressMain__1uJ2e`,
	"completeProfileTitle": `Survey_completeProfileTitle__CtxGy`,
	"getStartRow": `Survey_getStartRow__aNRDP`,
	"modalBody": `Survey_modalBody__WYvGJ`,
	"header": `Survey_header__NYGPq`,
	"formField": `Survey_formField__e65CP`,
	"label": `Survey_label__40GBi`,
	"photographyTimelineRow": `Survey_photographyTimelineRow__k934z`,
	"deleteRowBtn": `Survey_deleteRowBtn__tcVyl`,
	"formWrp": `Survey_formWrp__73r1W`,
	"ceremonyForm": `Survey_ceremonyForm__jgVfd`,
	"checkFormField": `Survey_checkFormField__Dg-Xv`,
	"receptionForm": `Survey_receptionForm__ii9bY`,
	"fieldTitle": `Survey_fieldTitle__z2oQI`
};
export default ___CSS_LOADER_EXPORT___;
